import React from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import Box from '@amzn/meridian/box';
import Text from '@amzn/meridian/text';
import { useAppSelector } from 'src/store/store';
import { setRestrictionListItem } from 'src/store/newJmrPageSlice/newJmrPageSlice';
import { TimeRestrictionTask } from 'src/utils/restrictionUtils';
import HoursSelector from './hoursSelector';

/**
 * Select time restriction for a non-consolidated task type
 */
const TimeRestrictionField = (props: { listIndex: number }) => {
  const { listIndex, ...otherProps } = props;
  const dispatch = useDispatch();
  const { restrictionListItems } = useAppSelector((state) => state.newJmrPage);
  const task = restrictionListItems[listIndex] as TimeRestrictionTask;

  return (
    <Box {...otherProps}>
      <Box>
        <Text data-testid="new-jmr__time-restriction-field-label">
          Associate cannot perform: <b>{task?.label}</b> exceeding (hrs) *
        </Text>
        <HoursSelector
          task={task}
          onChange={(task) => dispatch(setRestrictionListItem({ item: task, index: listIndex }))}
          listIndex={listIndex}
        />
      </Box>
    </Box>
  );
};

export default TimeRestrictionField;
